import cloneDeep from 'lodash.clonedeep';
import types from './actionTypes';
const shortUUid = require("short-uuid");

const initialState = {
    id: shortUUid.generate(),
    name: "Utility Functions",
    type: 10,
    data: ""
};

export default function appReducer(state = initialState, action) {
    switch (action.type) {

        case types.ADD_UTILITY_FUNCTIONS: {
            return {
                ...initialState,
                data: action.payload
            }
        }

        case types.EDIT_UTILITY_FUNCTIONS: {
            return {
                ...initialState,
                data: action.payload
            }
        }

        case types.DELETE_UTILITY_FUNCTIONS: {
            return initialState;
        }

        case types.UPDATE_UTILITY_FUNCTIONS: {
            return {
                ...state,
                ...action.payload
            }
        }

        case types.RESET_UTILITY_FUNCTIONS: {
            return {
                //   ...state,
                ...action.payload
            }
        }

        case 'RESET_BLUEPRINT':
            return cloneDeep(initialState);

        default:
            return state;
    }
}